import { apiClient, retryRequest } from './httpClient';

export async function accessToken(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'POST',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'POST request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'POST';
        throw err;
    }
}